<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="dataModel"
               label-width="120px">

        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="一级审核"
                          prop="first_approver">
              <remote-select class="width-max"
                             clearable
                             id-key="id"
                             keyword-key="name"
                             label-key="name"
                             value-key="id"
                             placeholder="请输入管理员名称搜索"
                             v-model="dataModel.first_approver"
                             :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                             :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="二级审核"
                          prop="second_approver">
              <remote-select class="width-max"
                             clearable
                             id-key="id"
                             keyword-key="name"
                             label-key="name"
                             value-key="id"
                             placeholder="请输入管理员名称搜索"
                             v-model="dataModel.second_approver"
                             :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                             :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="财务审核"
                          prop="finance_approver">
              <remote-select class="width-max"
                             clearable
                             id-key="id"
                             keyword-key="name"
                             label-key="name"
                             value-key="id"
                             placeholder="请输入管理员名称搜索"
                             v-model="dataModel.finance_approver"
                             :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                             :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="收件人"
                          prop="receiver">
              <remote-select class="width-max"
                             clearable
                             multiple
                             :multiple-limit=30
                             id-key="id"
                             keyword-key="name"
                             label-key="name"
                             value-key="id"
                             placeholder="请输入管理员名称搜索"
                             v-model="dataModel.receiver"
                             :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status: 1}))"
                             :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
          </div>
        </div>

        <el-row class="form-panel">
          <el-button type="primary"
                     size="mini"
                     @click="save()">保存
          </el-button>
          <el-button size="mini"
                     @click="$router.go(-1)">
            <span>返回</span>
          </el-button>
        </el-row>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  computed: {
    ...Vuex.mapState({}),
  },
  watch: {},
  data () {
    return {
      dataModel: {
        first_approver: null,
        second_approver: null,
        finance_approver: null,
        receiver: [],
      },
    }
  },
  created () {
    this.setConfig()
  },
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    onLoad () {
      this.setConfig()
    },
    setConfig () {
      return request.common('getProjectConfig', {}).then(({data}) => {
        this.dataModel.receiver = data.receiver.map((item) => item * 1)
        this.dataModel.first_approver = data.first_approver * 1
        this.dataModel.second_approver = data.second_approver * 1
        this.dataModel.finance_approver = data.finance_approver * 1
      })
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    save () {
      const params = filter.copyJson(this.dataModel)
      request.common('setProjectConfig', params).then((res) => {
        this.$message.success('配置保存成功')
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/pages/SetProjectConfig.vue